import { deepFreeze } from '../../util/deepFreeze';
/** Lithuanian translations translations */
export var ltTranslations = {
    Apr: 'Bal',
    Aug: 'Rug',
    contributions: {
        0: 'kontribucijų nebuvo',
        other: 'kontribucijų:'
    },
    Dec: 'Gru',
    Feb: 'Vas',
    Friday: 'Pen',
    hideZero: true,
    Jan: 'Sau',
    Jul: 'Lie',
    Jun: 'Bir',
    Mar: 'Kov',
    May: 'Geg',
    Monday: 'Pir',
    Nov: 'Lap',
    Oct: 'Spa',
    order: 5 /* DATE_TEXT_COUNT */,
    Sep: 'Rug',
    Wednesday: 'Tre'
};
deepFreeze(ltTranslations);



//////////////////
// WEBPACK FOOTER
// ./src/GhContribCalendar/Translate/defaultTranslations/lt.ts
// module id = 26
// module chunks = 0 1